// chat.component.ts
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  TemplateRef,
} from '@angular/core';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import {
  ChatChannel,
  ChatMessage,
  ChatService,
} from 'src/app/services/chat.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit, OnDestroy, AfterViewInit {
  currentUser: any;
  messages: ChatMessage[] = [];
  users: any[] = [];
  currentChannel: ChatChannel | null = null;
  newMessage = '';
  activeModal = false;
  activeModalRef!: NgbModalRef;
  isMessageSending = false;

  @ViewChild('scrollableMsg') private scrollableMsg!: ElementRef;

  private subscriptions: Subscription[] = [];

  constructor(
    private chatService: ChatService,
    private modalService: NgbModal
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.scrollToBottom();
    }, 400);
  }

  ngOnInit() {
    this.subscriptions.push(
      this.chatService.currentUser$.subscribe((currentUser) => {
        this.currentUser = currentUser;
      }),
      this.chatService.messages$.subscribe((messages) => {
        this.messages = messages;
        this.scrollToBottom();
      }),
      this.chatService.currentChannel$.subscribe((channel) => {
        this.currentChannel = channel;
      }),
      this.chatService.getUsers().subscribe((users) => {
        this.users = users;
      }),
      this.chatService.messageSent$.subscribe((isSending) => {
        this.isMessageSending = isSending;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  sendMessage() {
    if (
      this.newMessage.trim() &&
      this.currentChannel &&
      this.currentChannel?.id !== null
    ) {
      this.chatService
        .sendMessage(
          this.newMessage,
          this.currentUser.id,
          this.currentChannel.id
        )
        .subscribe(() => {
          this.newMessage = '';
          this.chatService.updateMessages(this.currentChannel?.id!);
        });
    }
  }

  getUserName(userId: number): string {
    const user = this.users.find((u) => u.id === userId);
    return user ? `${user.firstName} ${user.lastName}` : 'Utilisateur inconnu';
  }

  getUserInitials(userId: number): string {
    const user = this.users.find((u) => u.id === userId);
    if (user) {
      return (
        (user.firstName || '?')
          .split(' ')
          .map((n: any) => n[0])
          .join('')
          .toUpperCase() +
        (user.lastName || '?')
          .split(' ')
          .map((n: any) => n[0])
          .join('')
          .toUpperCase()
      );
    }
    return 'UN';
  }

  scrollToBottom(): void {
    setTimeout(() => {
      try {
        let elements = document.getElementsByName('messages') || [];
        elements.forEach((element: any) => {
          element.scrollTop = element.scrollHeight - element.clientHeight + 30; // Compense les 15px de padding
        });
        // if (element) {
        //   //const element = this.scrollableMsg.nativeElement;
        //   element.scrollTop = element.scrollHeight - element.clientHeight + 30; // Compense les 15px de padding
        // }
      } catch (err) {
        console.error('Error scrolling to bottom:', err);
      }
    }, 200);
  }

  openModal(modal: TemplateRef<any>) {
    this.activeModal = true;

    const options: NgbModalOptions = {
      size: 'lg',
      windowClass: 'chat-modal',
    };
    this.activeModalRef = this.modalService.open(modal, options);

    this.scrollToBottom();
  }

  closeModal() {
    this.activeModal = false;
    if (this.activeModalRef) {
      this.activeModalRef.close();
    }
  }
}
